import React, {useEffect, useState} from "react";
import {observer} from "mobx-react-lite";
import {useGuideFlowProviderContext} from "../../../../GuideFlowProviderContext";
import {Contact} from "../../../../providers/contact/ContactProvider";
import {LoadingPanel} from "../../vidence/blanks/LoadingPanel";

interface ContactNameProps {
    id: string,
    className?: string,
    onClick?: () => void
}

export const ContactName = observer((props: ContactNameProps) => {
    const context = useGuideFlowProviderContext();
    const [contact, setContact] = useState<Contact>();
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        context.Contacts.get(props.id).then((contact) => {
            setContact(contact);
            setLoaded(true);
        });
    }, [context.Contacts, context.Contacts.StateChanged, props.id]);

    if (!loaded) {
        return <LoadingPanel text="..."/>
    }

    if (!contact) {
        return <div>info missing</div>
    }

    return (
        <>
            <div className="min-w-0 flex-auto">
                <p className="text-sm font-semibold leading-6 text-gray-900">
                    {contact.firstname} {contact.surname}
                </p>
            </div>
        </>
    )
})
